import { render, staticRenderFns } from "./SensibleTrunkAnalysis.vue?vue&type=template&id=15892365&scoped=true"
import script from "./SensibleTrunkAnalysis.vue?vue&type=script&lang=ts"
export * from "./SensibleTrunkAnalysis.vue?vue&type=script&lang=ts"
import style0 from "./SensibleTrunkAnalysis.vue?vue&type=style&index=0&id=15892365&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15892365",
  null
  
)

export default component.exports